var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFastLoans = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 230,
    height: 149,
    viewBox: "0 0 230 149",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6468_20568)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M183.674 44.1504H114.98V125.658H183.674V44.1504Z",
    fill: "#006EF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.98 44.1504H44.1504V125.658H114.98V44.1504Z",
    fill: "#00EC25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.693 44.1504H183.675V125.658H183.693V44.1504Z",
    fill: "#00EC25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.674 125.658H114.98V126.975H183.674V125.658Z",
    fill: "#6BB6FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.646 99.6539V70.1537C163.005 70.1537 155.998 63.1485 155.998 54.502H114.98V115.306H155.998C155.998 106.661 163.003 99.6539 171.646 99.6539Z",
    fill: "#6BB6FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.8455 54.5044C71.8455 63.1489 64.8403 70.1561 56.1978 70.1561V99.6563C64.8383 99.6563 71.8455 106.662 71.8455 115.308H114.98V54.5044H71.8455Z",
    fill: "#F0F8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.1503 44.1503H88.3007C88.3027 19.7681 68.5346 0 44.1503 0C19.7661 0 0 19.7681 0 44.1503C0 68.5326 19.7681 88.3007 44.1503 88.3007V44.1503Z",
    fill: "#6BB6FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.691 125.658H44.1504V148.395H183.691V125.658Z",
    fill: "#091F83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.1502 44.1502H78.1046C78.1046 25.3977 62.9027 10.1958 44.1502 10.1958C25.3977 10.1958 10.1978 25.3997 10.1978 44.1502C10.1978 62.9007 25.3997 78.1046 44.1522 78.1046V44.1502H44.1502Z",
    fill: "#F0F8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.1504 44.1504V88.3007C68.5346 88.3007 88.3007 68.5326 88.3007 44.1504H44.1504Z",
    fill: "#006EF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.1288 44.1504H44.1504V78.1288C62.9149 78.1288 78.1288 62.9169 78.1288 44.1504Z",
    fill: "#6BB6FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.749 125.658H101.094V148.395H126.749V125.658Z",
    fill: "#091F83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.1504 133.201H183.691",
    stroke: "#006EF5",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.1504 140.854H183.691",
    stroke: "#006EF5",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2285 9.95996V44.4482H67.981",
    stroke: "#232323",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.548 99.6802V70.186H115.108V99.6802H195.548Z",
    fill: "#C17C87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.754 99.7222V70.146H171.777V99.7222H183.754Z",
    fill: "#091F83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.632 125.938V44.1104L230 85.024L183.632 125.938Z",
    fill: "#FFCEC2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.938 32.6089L159 25.8276V39.5202L169.938 32.6089Z",
    stroke: "#232323",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.323 32.6089L170.386 25.8276V39.5202L181.323 32.6089Z",
    stroke: "#232323",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6468_20568"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 230,
    height: 148.397,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFastLoans);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/FastLoans.49ac0d50cbf7d9dd4940e5610e299fde.svg";